<mat-card>
  <mat-card-content>
    <ng-container *ngIf="statistics">
      <h4>Distributed</h4>
      <div class="flex justify-content-se text-center">
        <div class="f-item card-padding card-border">
          <div class="flex justify-content-se align-items-center height-100">
            <div
              class="c100 center p-0"
              [ngClass]="'p' + (statistics.invite_percentage | roundNumber: 0)"
            >
              <span>{{ statistics.invite_percentage | roundNumber: 0 }}%</span>
              <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
              </div>
            </div>

            <div class="f-item">
              <p class="mb-3">Employee inclusion</p>
              <p class="bold mb-0">
                {{ statistics.total_unique_invites | formatNumber }}/{{
                  statistics.total_users | formatNumber
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="f-item card-padding card-border ml-4">
          <div class="flex justify-content-se align-items-center height-100">
            <div
              class="c100 center p-0"
              [ngClass]="
                'p' +
                ((statistics.usergroups_invited / statistics.total_usergroups) *
                  100 | roundNumber: 0)
              "
            >
              <span
                >{{
                  (statistics.usergroups_invited /
                    statistics.total_usergroups) *
                    100 | roundNumber: 0
                }}%</span
              >
              <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
              </div>
            </div>

            <div class="f-item">
              <p class="mb-3">Group activation</p>
              <p class="bold mb-0">
                {{ statistics.usergroups_invited | formatNumber }}/{{
                  statistics.total_usergroups | formatNumber
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="f-item card-padding card-border mx-4">
          <div class="flex justify-content-se align-items-center height-100">
            <div
              class="c100 center"
              [ngClass]="'p' + (statistics.opened_percentage | roundNumber: 0)"
            >
              <span>{{ statistics.opened_percentage | roundNumber: 0 }}%</span>
              <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
              </div>
            </div>

            <div class="f-item">
              <p class="mb-3">Email open rate</p>
              <p class="bold mb-0">
                {{ statistics.mailgun_opened_count | formatNumber }}
              </p>
            </div>
          </div>
        </div>

        <div class="f-item card-padding card-border">
          <div class="flex justify-content-sb align-items-center height-100">
            <div
              class="c100 center"
              [ngClass]="
                'p' + (statistics.total_engagement_unique | roundNumber: 0)
              "
            >
              <span
                >{{
                  statistics.total_engagement_unique | roundNumber: 0
                }}%</span
              >
              <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
              </div>
            </div>
            <div class="f-item">
              <p class="mb-3">Employee engagement</p>
              <p class="bold mb-0">
                {{ statistics.unique_shares_per_user | formatNumber }}/{{
                  statistics.total_unique_invites | formatNumber
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div
      *ngIf="statistics && currencySymbol"
      class="flex justify-content-se mt-4"
    >
      <div class="f-item">
        <div class="f-item flex flex-row mb-4">
          <div class="f-item card-border mr-4">
            <div class="card-title">
              <p class="m-0 bold text-center">Sent emails</p>
            </div>
            <div class="p-4">
              <div class="flex justify-content-sb">
                <p>Total sent</p>
                <p>{{ statistics.total_invites | formatNumber }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p>To individual users</p>
                <p>{{ statistics.total_unique_invites | formatNumber }}</p>
              </div>
            </div>
          </div>

          <div class="f-item mr-4 card-border">
            <div class="card-title">
              <p class="m-0 bold text-center">Email Campaigns</p>
            </div>
            <div class="p-4">
              <div class="flex justify-content-sb">
                <p>Regular</p>
                <p>{{ statistics.regular_share_post_count | formatNumber }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p>Direct</p>
                <p>{{ statistics.direct_share_post_count | formatNumber }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p>Video</p>
                <p>{{ statistics.video_share_post_count }}</p>
              </div>
            </div>
          </div>

          <div class="f-item mr-4 card-border">
            <div class="card-title">
              <p class="m-0 bold text-center">Shares</p>
            </div>
            <div class="p-4">
              <div class="flex justify-content-sb">
                <p>Content shared</p>
                <p>
                  <span [matTooltip]="'Total Shares Count'">{{ statistics.total_shares_count | formatNumber }}</span>
                  <span [matTooltip]="'Total Shares Count that is Confirmed'"> ({{ statistics.confirmed_shares_count | formatNumber }})</span>
                </p>
              </div>
              <div class="flex justify-content-sb">
                <p>Users shared (regular)</p>
                <p>{{ statistics.unique_shares_per_user | formatNumber }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p class="">Users shared (native)</p>
                <p class="">{{ statistics.native_content_users_activated | formatNumber }}</p>
              </div>
              <div *ngIf="statistics && statistics.unique_direct_shares_per_user !== undefined" class="flex justify-content-sb">
                <p class="m-0">Users shared (direct)</p>
                <p class="m-0">{{ statistics.unique_direct_shares_per_user | formatNumber }}</p>
              </div>
            </div>
          </div>

          <div class="f-item mr-4 card-border">
            <div class="card-title">
              <p class="m-0 bold text-center">Business outcome</p>
            </div>
            <div class="p-4">
              <div class="flex justify-content-sb">
                <p>Clicks</p>
                <p>{{ statistics.count_total_click | formatNumber }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p>View count</p>
                <p>{{ statistics.direct_share_view | formatNumber }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p>Click/Share</p>
                <p>{{ statistics.click_per_share | roundNumber: 2 }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p class="m-0">Content engagement</p>
                <p class="m-0">
                  <span [matTooltip]="'Total Engagement Count'">{{ statistics.total_engagement_count  | roundNumber: 0 | formatNumber}}</span>
                  <span [matTooltip]="'Total Engagement Count that is Confirmed'"> ({{statistics.confirmed_engagement_count | roundNumber: 0 | formatNumber}})</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <h4>SociuuHub</h4>
        <div class="f-item flex flex-row">
          <div class="f-item mr-4 card-border">
            <div class="card-title">
              <p class="m-0 bold text-center">Shares</p>
            </div>
            <div class="p-4">
              <div class="flex justify-content-sb">
                <p>Content shared</p>
                <p>
                  <span [matTooltip]="'Total Share Count'">{{ statistics.pull.total_shares_count | formatNumber | roundNumber: 0 }}</span>
                  <span [matTooltip]="'Total Share Count that is Confirmed'"> ({{statistics.pull.confirmed_shares_count | formatNumber | roundNumber: 0 }})</span>
                </p>
              </div>
              <div class="flex justify-content-sb">
                <p>Users shared</p>
                <p>{{ statistics.pull.users_activated | formatNumber }}</p>
              </div>

              <div class="flex justify-content-sb">
                <p>Users shared (native)</p>
                <p>{{ statistics.pull.native_content_users_activated | formatNumber }}</p>
                </div>
            </div>
          </div>

          <div class="f-item mr-4 card-border">
            <div class="card-title">
              <p class="m-0 bold text-center">Business outcome</p>
            </div>
            <div class="p-4">
              <div class="flex justify-content-sb">
                <p>Clicks</p>
                <p>{{ statistics.pull.clicks | formatNumber }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p>Click/Share</p>
                <p>{{ statistics.pull.clicks_per_share | roundNumber: 2 }}</p>
              </div>
              <div class="flex justify-content-sb">
                <p class="m-0">Content engagement</p>
                <p class="m-0">
                  <span [matTooltip]="'Total Engagement Count'">{{ statistics.pull.total_engagement_count | roundNumber: 0 | formatNumber}}</span>
                  <span [matTooltip]="'Total Engagement Count that is Confirmed'"> ({{statistics.pull.confirmed_engagement_count | roundNumber: 0 | formatNumber}})</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="f-item card-border w-20">
        <div class="card-title">
          <p class="m-0 bold text-center">EMV</p>
        </div>
        <div class="p-4 text-center align-items-center height-100">
          <h4 class="mb-10">
            {{ currencySymbol }}
            {{ statistics.total_emv_earned | roundNumber: 2 | formatNumber }}
          </h4>
          <div class="mb-5">
            <h5 class="mb-1">Distributed</h5>
            <h5>
              {{ currencySymbol }}
              {{
                statistics.total_emv_earned_push | roundNumber: 2 | formatNumber
              }}
            </h5>
          </div>
          <div>
            <h5 class="mb-1">SociuuHub</h5>
            <h5>
              {{ currencySymbol }}
              {{
                statistics.total_emv_earned_pull | roundNumber: 2 | formatNumber
              }}
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!statistics && !isLoadingStats" class="text-center p-8">
      There is no data for selected data interval
    </div>

    <div class="text-center p-8" *ngIf="isLoadingStats">Loading data...</div>
  </mat-card-content>
</mat-card>
